import { useTranslation } from 'gatsby-plugin-react-i18next';

export const handleFooterAccordian = (_el: any, _elAccordian: any) => {
  const isHidden = _el.classList.contains('hidden');
  isHidden ? _el.classList.remove('hidden') : _el.classList.add('hidden');
};

export const getTextFromHtml = (htmlInput: string) => htmlInput?.replace(/<\/?[^>]+(>|$)/g, '');

/**
 * Formats a string by removing special characters, whitespace, and converting to lowercase.
 *
 * @param {string} str - The input string to be formatted.
 * @returns {string} The formatted string with no special characters, no whitespace, and all lowercase.
 */
export const sanitizeAndLowercaseString = (str: string): string => {
  if (typeof str !== 'string') return '';
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
    .trim();
};

export const i18Format = (text: string, params?: Record<string, string>): string => {
  const { t } = useTranslation();
  let formattedText: string = t(text);
  if (!params || Object.keys(params).length === 0) return formattedText;
  Object.keys(params).forEach(key => {
    const text = formattedText.split(`{${key}}`);
    if (text.length > 1) {
      formattedText = text[0] + params[key] + text[1];
    }
  });
  return formattedText;
};

/**
 * Converts a string to title case. (first letter of each word is capitalized
 * and the rest is lowercased)
 *
 * @param {string} text - The input string to be converted to title case.
 * @returns {string} The input string converted to title case.
 */
export const toTitleCase = (text: string) => {
  return text?.toLowerCase()?.replace(/(?:^|\s)\w/g, function (match) {
    return match?.toUpperCase();
  });
};

export const errorMap: any = {
  benefits: 'something went wrong in benefits',
  warranties: 'something went wrong in warranties',
};
export const genrateError = (errorList: any) => {
  return errorList.map((err: any) => errorMap[err]).join(' , ');
};

export const replaceImageHost = (originalUrl: string, currentDomain: string, newDomain: string) => {
  try {
    if (!currentDomain || !newDomain) return originalUrl;
    const url = new URL(originalUrl);

    if (url.hostname === currentDomain) {
      url.hostname = newDomain;
    }

    return url.toString();
  } catch (error) {
    console.error('Invalid URL:', error);
    return originalUrl; // Return original if there's an error
  }
};

export function normalizeNoTrailingSlash(pathname: string) {
  return pathname.replace(/\/+$/, '');
}

export function ensureLeadingSlash(path: string) {
  return path.startsWith('/') ? path : `/${path}`;
}

export const buildUrl = (baseURL: string, endpointPath: string, envlbl: string) => {
  const url = new URL(baseURL);

  if (endpointPath && endpointPath.trim()) {
    const basePath = normalizeNoTrailingSlash(url.pathname || '/');
    const suffix = ensureLeadingSlash(endpointPath.trim());
    if (!basePath.endsWith(suffix)) {
      url.pathname = `${basePath}${suffix}`;
    } else {
      url.pathname = basePath;
    }
  }

  if (envlbl && envlbl.length) {
    url.searchParams.set('envlbl', envlbl);
  }
  return url.toString();
};
